<app-module-header [title]="(organization ? organization.organizationName + ' - ' : '') + ('REPORTS.TITLE' | transloco)"
  [icon]="'bar_chart'">
</app-module-header>

@if (isLoading) {
<mat-progress-bar mode="indeterminate" class="mb-2"></mat-progress-bar>
}

<div class="reports-dashboard-grid mt-2">
  @if (organization?.config?.handlesShuttles) {
  <div class="dashboard-item dashboard-shuttle">
    <div class="d-flex flex-row align-items-start justify-content-between w-100">
      <div class="fs-6 fw-bold d-flex flex-row align-items-center">
        <mat-icon class="me-2">airport_shuttle</mat-icon>
        <h3>Shuttle Operations</h3>
      </div>
      <div class="dashboard-controls-row">
        <mat-form-field appearance="outline" class="date-range-field">
          <mat-label>Date Range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate placeholder="Start date" [(ngModel)]="selectedStartDate" [disabled]="isLoading">
            <input matEndDate placeholder="End date" [(ngModel)]="selectedEndDate" [disabled]="isLoading"
              (dateChange)="onDateRangeChange()">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        <div class="d-flex align-items-center gap-2">
          <span class="time-axis-label">Time Axis</span>
          <mat-button-toggle-group [disabled]="isLoading" class="time-axis-btns" [(value)]="timeAxisMode"
            (change)="switchTimeAxis($event)">
            <mat-button-toggle value="days">Days</mat-button-toggle>
            <mat-button-toggle value="hours">Hours</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    </div>
    <div class="chart-container chart-container--lg">
      <canvas baseChart [data]="shuttleLineChartData" [options]="shuttleLineChartOptions" [type]="'line'"></canvas>
    </div>
  </div>
  }

  <div class="dashboard-item">
    <div class="d-flex flex-row align-items-start justify-content-between w-100">
      <div class="fs-6 fw-bold d-flex flex-row align-items-center">
        <mat-icon class="me-2">local_parking</mat-icon>
        <h3>Parking Statistics</h3>
      </div>
      <mat-form-field appearance="outline" class="parking-area-selector">
        <mat-label>Parking Area</mat-label>
        <mat-select [(ngModel)]="selectedParkingArea" (selectionChange)="onParkingAreaChange()"
          [disabled]="!parkingAreas.length">
          <mat-option value="all">All Parking Areas</mat-option>
          @for (area of parkingAreas; track area) {
          <mat-option [value]="area.parkingId">
            {{ area.parkingSiteName }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="chart-container chart-container--md">
      <canvas baseChart [data]="parkingBarChartData" [options]="parkingBarChartOptions" [type]="'bar'"></canvas>
    </div>
  </div>

  @if (organization?.config?.handlesShuttles) {
  <div class="dashboard-item">
    <div class="fs-6 fw-bold d-flex flex-row align-items-center mb-3">
      <mat-icon class="me-2">receipt_long</mat-icon>
      <h3>Orders by Source</h3>
    </div>
    <div class="chart-container chart-container--md">
      <canvas baseChart [data]="orderBarChartData" [options]="orderBarChartOptions" [type]="'bar'"></canvas>
    </div>
  </div>
  }

  @if (organization?.config?.handlesShuttles) {
  <div>
    <app-shuttle-compare [organization]="organization" (incrementRequests)="incrementRequests()"
      (decrementRequests)="decrementRequests()"></app-shuttle-compare>
  </div>
  }

</div>